function generateUniqueReferenceID(label) {
  label = label.split(" ").join("");
  // Get the current timestamp
  const timestamp = Date.now();

  // Generate a random alphanumeric string
  const randomPart = Math.random().toString(36).substring(2, 8).toUpperCase();

  // Combine "ADM", timestamp, and random part to create a unique ID
  const uniqueID = `${label}${timestamp}${randomPart}`;

  return uniqueID;
}

// Export the function
module.exports = generateUniqueReferenceID;
